export default {
    notifications: "Notificações",
    "no-notifications": "Não há notificações.",
    "load-more": "Carregar mais",
    "clear-all": "Limpar",
    "see-all": "Ver todas as notificações",
};
